// extracted by mini-css-extract-plugin
export default {"app":"ald_main__app__Rqb4K","mainColumn":"ald_main__mainColumn__Ct_LP","withPurpleDot":"ald_main__withPurpleDot__g9NDj"};